/* =============================================================================
   DmB perf — self-hosted hover/touch prefetch (instant.page-style).
   Speeds up navigation by prefetching the next document on hover/touch, BEFORE
   the click. Deliberately conservative & safe:
     • ONLY product (/products/) and collection (/collections/) links.
     • EXCLUDES cart, account, checkout, logout, orders, and ANY query-string URL
       (search/filter) — never prefetch action URLs (logout!) or faceted pages.
     • Respects Save-Data and slow (2g) connections, and data-no-instant opt-out.
   Improves perceived navigation; it does NOT change LCP of the landed page.
   ============================================================================= */
(function () {
  'use strict';
  if (!('querySelector' in document) || !document.head) return;

  // Bail on data-saver / slow networks.
  var conn = navigator.connection;
  if (conn && (conn.saveData || /(^|-)2g$/.test(conn.effectiveType || ''))) return;

  var supportsPrefetch = (function () {
    var l = document.createElement('link');
    return l.relList && l.relList.supports && l.relList.supports('prefetch');
  })();
  if (!supportsPrefetch) return;

  var ALLOW = /\/(products|collections)\//;
  // exclude cart/account/checkout/logout/orders/challenge paths, AND any URL with a query string
  var BLOCK = /\/(cart|account|checkout|logout|orders|challenge|apps|tools)(\/|$)|[?#]/;

  var prefetched = {};
  var hoverTimer;

  function eligible(a) {
    if (!a || a.tagName !== 'A' || !a.href) return false;
    if (a.origin !== location.origin) return false;            // same-origin only
    if (a.hasAttribute('data-no-instant')) return false;       // explicit opt-out
    var path = a.pathname + a.search;
    if (BLOCK.test(path)) return false;                         // cart/account/.../query
    if (!ALLOW.test(a.pathname)) return false;                 // product/collection only
    if (prefetched[a.href]) return false;
    return true;
  }

  function prefetch(href) {
    if (prefetched[href]) return;
    prefetched[href] = true;
    var link = document.createElement('link');
    link.rel = 'prefetch';
    link.href = href;
    link.as = 'document';
    document.head.appendChild(link);
  }

  function closestAnchor(el) {
    return el && el.closest ? el.closest('a') : null;
  }

  document.addEventListener('mouseover', function (e) {
    var a = closestAnchor(e.target);
    if (!eligible(a)) return;
    var href = a.href;
    clearTimeout(hoverTimer);
    // small delay so a cursor merely passing over a link doesn't trigger a fetch
    hoverTimer = setTimeout(function () { prefetch(href); }, 65);
  }, { capture: true, passive: true });

  document.addEventListener('mouseout', function () {
    clearTimeout(hoverTimer);
  }, { capture: true, passive: true });

  // Touch devices: prefetch on touchstart (no hover).
  document.addEventListener('touchstart', function (e) {
    var a = closestAnchor(e.target);
    if (eligible(a)) prefetch(a.href);
  }, { capture: true, passive: true });
})();
